<div class="survey-modal">
  <header>
    <h2 class="survey-modal__title">{{ survey().titulo }}</h2>
    <p
      class="survey-modal__description"
      [innerHTML]="survey().descricao | safeTransform: 'HTML'"
    ></p>
  </header>
  <form (submit)="handleSubmit()" class="survey-form" [formGroup]="form">
    <div class="survey-form__emotion-field-container">
      @for (emocao of survey().emocoes; track $index) {
        <label
          class="emotion-field"
          [style.--activePrimary]="EMOTION_CONFIG[emocao.status].color.primary"
          [style.--activeSecondary]="
            EMOTION_CONFIG[emocao.status].color.secondary
          "
          [class.emotion-field--selected]="emotion.value === emocao.status"
        >
          <svg-icon
            class="emotion-field__icon"
            [src]="EMOTION_CONFIG[emocao.status].icon"
          ></svg-icon>
          <span class="emotion-field__title">{{ emocao.titulo }}</span>
          <input
            type="radio"
            [value]="emocao.status"
            formControlName="emotion"
            (change)="onEmotionChange()"
            hidden
          />
        </label>
      }
    </div>
    @if (isEmotionValid) {
      <div class="survey-form__tag-field-section">
        <h3>O que motivou a sua resposta?</h3>
        <div class="survey-form__tag-field-container" formArrayName="tags">
          @for (control of tags.controls; track $index; let i = $index) {
            <label
              class="tag-field"
              [class.tag-field--selected]="control.get('checked').value"
              [formGroupName]="i"
            >
              <span>{{ survey().tags[i].texto_tag }}</span>
              <input type="checkbox" formControlName="checked" hidden />
            </label>
          }
        </div>
      </div>
    }

    <div class="comment-field">
      <label class="comment-field__label" for="comment">{{
        'survey_modal.comment' | translate
      }}</label>
      <commons-textarea
        id="comment"
        [small]="true"
        [rounded]="true"
        [autofocus]="true"
        [maxlength]="324"
        [placeholder]="'survey_modal.response_placeholder' | translate"
        formControlName="comment"
      ></commons-textarea>
    </div>
    <footer class="survey-form__footer">
      <commons-button
        [buttonText]="'buttons.to_see_later' | translate"
        [round]="true"
        [large]="true"
        [whitePurple]="true"
        (buttonClick)="handleFinishLater()"
        [full]="true"
      ></commons-button>
      <commons-button
        [buttonText]="'buttons.concluded' | translate"
        [round]="true"
        [large]="true"
        [isLoading]="false"
        [disabled]="!isEmotionValid"
        [isLoading]="savingSurveyResponse"
        type="submit"
        [full]="true"
      ></commons-button>
    </footer>
  </form>
</div>
